import { PATH_ROUTING } from 'src/app/shared/enums/routing-enums';
import { Component, OnInit, ViewChild } from '@angular/core';
import { EventManagerService } from 'src/app/core/services/event-manager.service';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import { MaterialApplicationTrainingDocument, ApplicationTrainingDocument } from 'src/app/shared/model/application-training-document.model';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UploadFile } from 'src/app/shared/model/file.model';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { PrivewImgDialogComponent } from 'src/app/shared/components/preview-file/preview-img/preview-img.component';
import { TYPE_FILE } from 'src/app/shared/enums/data-mock-enums';
import { ApplicationTrainingDocumentDetailService } from 'src/app/shared/service/application-training-document-detail.service';
import { Spinner } from 'src/app/core/services/spinner.service';
import { FileSerice } from 'src/app/shared/service/file.service';
import { Location } from '@angular/common';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ADMINTYPE } from '../admin.component';
import { API_URL } from 'src/app/shared/enums/api-enums';

@Component({
  selector: 'app-training-document-detail',
  templateUrl: './training-document-detail.component.html',
  styleUrls: ['./training-document-detail.component.scss'],
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '(window:resize)': 'onWindowResize($event)'
  }
})
export class TrainingDocumentDetailComponent implements OnInit {
  @ViewChild('fileInput') fileInput;
  tyeFile = TYPE_FILE;
  isShow = true;
  isEditMode = false;
  isMobile = false;
  regiForm: FormGroup;
  applicationTrainingDocument: ApplicationTrainingDocument = new ApplicationTrainingDocument();
  width: number = window.innerWidth;
  mobileWidth = 760;
  types = [TYPE_FILE.KEY_DOCUMENT, TYPE_FILE.KEY_VIDEO];
  files = [];
  imageUrl: any = '../../../../../../assets/images/empty-image.png';
  editFile = true;
  removeUpload = false;
  docFile;
  resourceOld: any;
  type = '';
  APIType = '';

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private spinner: Spinner,
    private service: FileSerice,
    private location: Location,
    private documentTrainingService: ApplicationTrainingDocumentDetailService,
    private eventManager: EventManagerService,
    private router: Router) {
    this.route.url.subscribe(res => {
      if (res[0].path === PATH_ROUTING.PATH_TRAINING_DOCUMENT_ADMIN_ADD || res[0].path === 'edit-application-training-document') {
        this.APIType = API_URL.APPLICATION_TRAINING_URL;
      } else {
        this.APIType = API_URL.CONFIDENTIAL;
      }
      if (res[1]) {
        const id = res[1].path;
        this.isEditMode = true;
        this.spinner.show();
        this.documentTrainingService.getApplicationTrainingDocumentByID(id, this.APIType).subscribe(resp => {
          this.spinner.hide();
          this.applicationTrainingDocument = new ApplicationTrainingDocument(resp.data);
          this.initForm();
          if (this.applicationTrainingDocument.thumbnail) {
            this.imageUrl = this.applicationTrainingDocument.thumbnail.resourceUrl;
          }
        });
      }
    });
  }

  ngOnInit(): void {
    this.initForm();
    this.eventManager.subscribe('SHOW_SIDEBAR', (res) => {
      this.isShow = res.data.isShow;
    });
    this.isMobile = this.width < this.mobileWidth;
  }

  onWindowResize(event) {
    this.width = event.target.innerWidth;
    this.isMobile = this.width < this.mobileWidth;
    if (this.width < this.mobileWidth) {
      this.isShow = true;
    }
  }

  initForm() {
    this.regiForm = this.fb.group({
      id: [this.applicationTrainingDocument.id],
      name: [this.applicationTrainingDocument.name, [Validators.required]],
      thumbnail: [this.applicationTrainingDocument.thumbnail],
      thumbnailOld: [this.applicationTrainingDocument.thumbnail || null],
      materials: this.fb.array(this.applicationTrainingDocument.materials.length ?
        this.applicationTrainingDocument.materials
          .map((material: MaterialApplicationTrainingDocument, index) => this.initMaterial(material))
        : [this.initMaterial(new MaterialApplicationTrainingDocument())]),
    });
    return this.regiForm;
  }

  initMaterial(material: MaterialApplicationTrainingDocument) {
    const materialForm = this.fb.group({
      id: [material.id],
      materialName: [material.materialName, [Validators.required]],
      type: [material.type || TYPE_FILE.KEY_DOCUMENT],
      resource: [material.resource],
      resourceOld: [material.resource],
      resourceCurent: [null],
      url: [material.url, [Validators.required]],
    });
    if (materialForm.controls.type.value === this.tyeFile.KEY_DOCUMENT) {
      materialForm.controls.url.setErrors(null);
      if (materialForm.controls.resource.value) {
        materialForm.controls.url.disable();
      }
    } else {
      materialForm.controls.url.setErrors({ required: true });
    }
    return materialForm;
  }

  addMaterial() {
    const control = this.regiForm.controls.materials as FormArray;
    control.push(this.initMaterial(new MaterialApplicationTrainingDocument()));
  }

  selectTypeMaterial(materialForm: FormGroup) {
    if (materialForm.controls.type.value === this.tyeFile.KEY_DOCUMENT) {
      materialForm.controls.url.setErrors(null);
      if (materialForm.controls.resource.value) {
        materialForm.controls.url.disable();
      }
    } else {
      materialForm.controls.url.setErrors({ required: true });
      materialForm.controls.url.enable();
    }
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  checkValidatorVideoUrl() {
    const control = this.regiForm.controls.materials as FormArray;
    const regexp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
    const vid = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(\?\S*)?$/;
    control.controls.forEach((material: FormGroup) => {
      if (material.value.type === TYPE_FILE.KEY_VIDEO) {
        if (!(material.value.url || '').match(vid)) {
          material.controls.url.setErrors(regexp.test(material.value.url)
            && material.value.url.includes('.mp4') ? null : { noVideoUrl: true });
        }
      } else {
        if (material.value.url) {
          material.controls.url.setErrors(regexp.test(material.value.url) ? null : { noDocumentUrl: true });
        }
      }
    });
    return control;
  }

  submitRegiForm(): void {
    this.checkValidatorVideoUrl();
    const checkValid = this.checkValidForm();
    if (!this.regiForm.valid) {
      this.markFormGroupTouched(this.regiForm);
      return;
    } else if (checkValid) {
      this.toastr.error(MESSAGE_TOAST.ERROR_SAVE_FILE);
    } else {
      this.confirmSubmitForm();
    }
  }

  confirmSubmitForm() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_ADD_APPLICATION,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        if (this.regiForm.controls.thumbnail.value) {
          this.submitThumbnail();
        } else {
          this.submitForm();
          this.deleteResource();
        }
      }
    });
  }

  checkValidForm() {
    const control = this.regiForm.controls.materials as FormArray;
    let checkValid;
    control.value.find((data: any) => {
      if (data.type === this.tyeFile.KEY_DOCUMENT && data.resource && !data.resource.resourceId) {
        checkValid = data;
      }
    });
    return checkValid ? true : false;
  }

  submitForm() {
    const body = new ApplicationTrainingDocument(this.regiForm.getRawValue(), false).convertToReqBody();
    if (this.regiForm.controls.id.value) {
      this.documentTrainingService.editApplicationTrainingDocument(this.regiForm.controls.id.value, body, this.APIType)
        .subscribe((data) => {
          this.spinner.hide();
          this.toastr.success(MESSAGE_TOAST.EDIT_DOCUMENT_TRAINING_DETAIL_SUCCESS);
          this.location.back();
        });
    } else {
      this.documentTrainingService.postApplicationTrainingDocument(body, this.APIType).subscribe((data) => {
        this.spinner.hide();
        this.toastr.success(MESSAGE_TOAST.ADD_DOCUMENT_TRAINING_DETAIL_SUCCESS);
        this.location.back();
      });
    }
  }

  deleteResource() {
    if (this.regiForm.controls.thumbnailOld.value) {
      this.service.delete(this.regiForm.controls.thumbnailOld.value.resourceId, this.tyeFile.THUMBNAIL, this.APIType)
        .subscribe((data) => { });
    }
  }

  submitMaterialForm(materialForm: FormGroup): void {
    this.spinner.show();
    this.service.upload(materialForm.controls.resource.value, this.tyeFile.DOCUMENT, this.APIType).subscribe((res) => {
      materialForm.controls.resource.setValue(res.data);
      if (materialForm.controls.resourceCurent.value && materialForm.controls.resourceCurent.value.resourceId) {
        if (materialForm.controls.resourceCurent.value.resourceId !== materialForm.controls.resource.value.resourceId) {
          this.service.delete(materialForm.controls.resourceCurent.value.resourceId, this.tyeFile.DOCUMENT, this.APIType)
            .subscribe((data) => {
              materialForm.controls.resourceCurent.setValue(res.data);
            });
        }
      } else {
        materialForm.controls.resourceCurent.setValue(res.data);
      }
      this.spinner.hide();
      this.regiForm.markAsDirty({ onlySelf: true });
      this.toastr.success(MESSAGE_TOAST.ADD_FILE_SUCCESS);
    });
  }

  submitThumbnail() {
    this.spinner.show();
    if (this.regiForm.controls.thumbnail.value.resourceId) {
      this.submitForm();
    } else {
      this.service.upload(this.regiForm.controls.thumbnail.value, this.tyeFile.THUMBNAIL, this.APIType).subscribe((res) => {
        this.spinner.hide();
        this.regiForm.controls.thumbnail.setValue(res.data);
        this.spinner.show();
        this.submitForm();
        this.deleteResource();
      });
    }
  }

  deleteMaterial(index) {
    const control = this.regiForm.controls.materials as FormArray;
    control.removeAt(index);
    this.regiForm.markAsDirty({ onlySelf: true });
  }

  onFileInput(event, itemForm: FormGroup) {
    const file = event.target.files[0];
    this.docFile = event.target.files[0];
    const uploadFile = new UploadFile(file, false);
    if (uploadFile.file.size > 10485760) {
      this.toastr.error(
        MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC_SIZE
      );
    } else if (!uploadFile.type) {
      this.toastr.error(
        MESSAGE_TOAST.ERROR_CHOOSE_FILE_DOC
      );
    } else {
      this.removeAttachment(itemForm);
      itemForm.controls.resource.setValue(file);
      this.regiForm.markAsDirty({ onlySelf: true });
      itemForm.controls.url.reset();
      itemForm.controls.url.disable();
    }
  }

  removeAttachment(materialForm: FormGroup) {
    this.fileInput.nativeElement.value = '';
    materialForm.controls.resource.setValue(null);
    this.regiForm.markAsDirty({ onlySelf: true });
    if (materialForm.controls.type.value === this.tyeFile.KEY_DOCUMENT) {
      materialForm.controls.url.setErrors(null);
      materialForm.controls.url.enable();
    } else {
      materialForm.controls.url.setErrors({ required: true });
      materialForm.controls.url.enable();
    }
  }

  uploadFile(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.regiForm.controls.thumbnail.setValue(file);
        this.regiForm.markAsDirty({ onlySelf: true });
        this.imageUrl = reader.result;
        this.editFile = false;
        this.removeUpload = true;
      };
    }
  }

  removeImg() {
    this.regiForm.controls.thumbnail.setValue(null);
    this.regiForm.markAsDirty({ onlySelf: true });
    this.imageUrl = '../../../../../../assets/images/empty-image.png';
  }

  previewImg() {
    const dialogRef = this.dialog.open(PrivewImgDialogComponent, {
      width: `${this.width / 2}px`,
      maxHeight: '500px',
      data: {
        type: 'img',
        url: this.imageUrl,
      }
    });
  }
}
